import { useDebouncedValue } from '@mantine/hooks';
import { useState } from 'react';

import { SortDirection } from '@feature/utils';

export function useSearch() {
  const [value, setValue] = useState('');
  const [search] = useDebouncedValue(value, 1600);

  return {
    search,
    searchProps: {
      value,
      setValue,
    },
  };
}

export function useSortDirection(defaultSortDirection: SortDirection) {
  const [sortDirection, setSortDirection] = useState(defaultSortDirection);

  const toggleSortDirection = () => setSortDirection(oldV => (oldV === 'ASC' ? 'DESC' : 'ASC'));

  return {
    sortDirection,
    toggleSortDirection,
  };
}
